(function ($) {
  
  //console.log('here12');
  $(".mobile-menu__toggle-button").click(function(){

  	//console.log('here_reched');


   $(".mobile-menu__toggle-icon").toggleClass("is-active");

    	//console.log('here_reched 2');
  });
  
  $(".ajax-cart__button").click(function(){
      console.log($(".cart__count--text").html());
      $( ".ajax-cart__form .ajax-cart__product-title" ).each(function( index ) {
        console.log( index + ": " + $( this ).text() );
      });
  });
  
})(jQuery);